import React from 'react';
import ServiceTemplate from '@/components/ServiceTemplate';

const CarrelageRevetements = () => {
  return (
    <ServiceTemplate
      title="Carrelage & Revêtements"
      heroImage="https://images.unsplash.com/photo-1630840450974-7c7ddad8bdfe?w=1600"
      description="Pose professionnelle de carrelage et revêtements pour une salle de bains moderne et durable."
      priceRange="5’000 - 15’000 CHF"
      duration="1-2 semaines"
      features={[
        'Large choix de carrelages et matériaux',
        'Pose professionnelle au sol et aux murs',
        'Étanchéité optimale contre l\'humidité',
        'Joints résistants aux moisissures',
        'Finitions soignées et précises',
        'Conseil sur le choix des matériaux'
      ]}
      includes={[
        {
          title: 'Carrelage mural',
          description: 'Pose de carrelage sur les murs avec étanchéité parfaite'
        },
        {
          title: 'Carrelage au sol',
          description: 'Installation de carrelage antidérapant et durable'
        },
        {
          title: 'Étanchéité',
          description: 'Système d\'étanchéité complet contre l\'humidité'
        },
        {
          title: 'Joints',
          description: 'Joints de qualité résistants aux moisissures'
        },
        {
          title: 'Préparation',
          description: 'Préparation et nivellement des surfaces'
        },
        {
          title: 'Finitions',
          description: 'Coupes précises et angles parfaits'
        }
      ]}
      benefits={[
        'Large gamme de styles et couleurs disponibles',
        'Matériaux de qualité supérieure et durables',
        'Protection optimale contre l\'humidité',
        'Entretien facile et longève',
        'Valorisation esthétique de votre salle de bains',
        'Garantie sur la pose et les matériaux'
      ]}
    />
  );
};

export default CarrelageRevetements;